let imageMap = {};

// Sets imageJson to share globally json.
export const setImageMap = (imageJson) => {
  imageMap = imageJson;
};

// Get imageMap json.
export const getImageMap = () => imageMap;
